module.exports = __webpack_public_path__ + "img/magento-setup-tuning_medium.11683a18.jpg";